import { render, staticRenderFns } from "./ConcessionBiometryVerify.vue?vue&type=template&id=c967d1f6"
import script from "./ConcessionBiometryVerify.vue?vue&type=script&lang=js"
export * from "./ConcessionBiometryVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports